
import { useEffect, useMemo, useState } from "react";
import { Button, Form, Offcanvas, Row, Col, Spinner } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import "react-phone-input-2/lib/style.css";
import { toast } from "sonner";
import Select from "react-select";
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from "../../Utils/hooks/ApiHandler";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";
import { customStyles } from "../../Utils/helpers/commonhelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEquals,
  faI,
  faPen,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DeleteModal from "../DeleteModal";
import { SubmitBtn } from "../../CommonComponents/Buttons/SubmitBtn";
import { CancelBtn } from "../../CommonComponents/Buttons/CancelBtn";
const projectSchema = z.object({
  title: z.string().min(1, "Title is required"),
  webhook_url: z.string().optional(),
  owner_id: z.string().min(1, "Owner is required"),
  startDate: z.string().min(1, "Start date is required"),
  endDate: z.string().min(1, "End date is required"),
  projectStages: z
    .array(
      z.object({
        stage_name: z.string(),
        id: z.string().optional(),
      })
    )
    .min(1, "At least one project stage is required"),
  salesOrder: z.string().optional(),
  contact: z.string().min(1, "Contact is required"),
  tags: z.array(z.string()).optional(),
  description: z.string().optional(),
});
export const CreateProject = ({ show, setProjectOffcanvas, project_id, setEditMode, editedMode, setProject_id, fetchProjectList, refetch, moduleName }) => {
  const { headers, extras, customerId, loginUserId, userType } = useGetEssentials();
  const today = new Date().toISOString().split("T")[0];
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const tomorrow = tomorrowDate.toISOString().split("T")[0];
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(projectSchema),
    mode: "onChange",
    defaultValues: {
      title: "",
      owner_id: "",
      startDate: today,
      endDate: tomorrow,
      projectStages: [],
      salesOrder: "",
      contactPerson: "",
      tags: [],
      description: "",
    },
  });
  const [projectStages, setProjectStages] = useState([]);
  const [currentStage, setCurrentStage] = useState("");
  const [tags, setTags] = useState([]);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDataFetching, setIsDataFetching] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [stageToDelete, setStageToDelete] = useState(null);
  const [indexToRemove, setIndexToRemove] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModal1, setShowDeleteModal1] = useState(false);
  const [isSubmitButtonIsClicked, setSubmitButtonIsCliked] = useState(false);
  // delete modal loading state
  const [loading, setLoading] = useState(false)
  const [isOwnerSame, setIsOwnerSame] = useState(false)
  const [leadOwner, setLeadOwner] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [salesOrderOptions, setSalesOrderOptions] = useState([
  ]);
  const [contactId, setContactId] = useState(null);
  const [contactOption, setContactOption] = useState([]);
  const StartDate = watch("startDate");
  const EndDate = watch("endDate");
  const qDate = new Date(StartDate);
  const eDate = new Date(EndDate);
  const addProjectStage = () => {
    if (currentStage.trim()) {
      const newStage = { id: "", stage_name: currentStage.trim() }
      const newStages = [...projectStages, newStage]
      setProjectStages(newStages)
      setValue("projectStages", newStages)
      setCurrentStage("")
    }
  }
  const removeProjectStage = (indexToRemove) => {
    const newStages = projectStages.filter(
      (_, index) => index !== indexToRemove
    );
    setProjectStages(newStages);
    setValue("projectStages", newStages);
  };
  // delete by stage_id (API delete success ke baad)
  const removeProjectStageById = (stageId) => {
    const newStages = projectStages.filter(
      (stage) => stage.stage_id !== stageId
    );
    setProjectStages(newStages);
    setValue("projectStages", newStages);
  };
  const handleStageKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addProjectStage();
    }
  };
  // Drag and drop functionality for project stages
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleSelectChange = (name, selectedOption, fieldOnChange) => {
    fieldOnChange(selectedOption?.value || "");
    if (name === "contact") {
      setSelectedContact(selectedOption);
      setContactId(selectedOption ? selectedOption.value : null);
    }
  };
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = Number.parseInt(e.dataTransfer.getData("text/plain"));
    const newStages = [...projectStages];
    const draggedItem = newStages[dragIndex];
    newStages.splice(dragIndex, 1);
    newStages.splice(dropIndex, 0, draggedItem);
    setProjectStages(newStages);
    setValue("projectStages", newStages);
  };
  const handleEdit = (index) => {
    setEditIndex(index)
    setEditValue(
      typeof projectStages[index] === "object"
        ? projectStages[index].stage_name
        : projectStages[index]
    )
  }
  const handleSaveEdit = (index) => {
    const updatedStages = [...projectStages]
    if (typeof updatedStages[index] === "object") {
      updatedStages[index] = {
        ...updatedStages[index],
        stage_name: editValue,
      }
    } else {
      updatedStages[index] = { id: "", stage_name: editValue }
    }
    setProjectStages(updatedStages)
    setEditIndex(null)
    setEditValue("")
  }
  useEffect(() => {
    (async () => {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customerId}`,
        { headers },
        extras
      );
      if (res.err) {
        toast.error("Error Fetching Data");
      }
      const owners =
        res.data &&
        res.data.map((lead) => ({
          leadName: lead.full_name,
          leadId: lead.id,
        }));
      setLeadOwner(owners);
      if (owners && owners.length > 0) {
        setValue("owner_id", loginUserId);
      }
    })();
  }, []);
  const fetchAllContacts = async () => {
    try {
      const res = await GetRequest(
        `quotation/fetchContacts/${loginUserId}/${customerId}/${userType}`,
        { headers },
        extras
      );
      if (res.status !== "success") {
        return toast.error(res.message || "Failed to find contacts");
      }
      if (Array.isArray(res.data)) {
        const data = res.data.map((contact) => {
          let billingAddresses = [];

          if (contact.billing_address) {
            try {
              billingAddresses = JSON.parse(contact.billing_address);
            } catch (e) {
              console.error("Billing address parse error:", e);
            }
          }
          if (billingAddresses.length === 0) {
            billingAddresses.push({
              address: contact.address,
              city: contact.city_name,
              state: contact.state_name,
              country: contact.country_name,
              zipcode: contact.zipcode,
              selected: "selected",
              for: "billing",
            });
          }
          const shippingAddresses = [...billingAddresses];
          return {
            contactName: contact.contact_full_name,
            contactId: contact.id,
            company_id: contact.company_id,
            company_name: contact.company_name,
            billingAddresses,
            shippingAddresses,
          };
        });
        setContactOption(data);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error("Something went wrong while fetching contacts");
    }
  };
  useEffect(() => {
    fetchAllContacts();
  }, []);
  const fetchAllSalesOrder = async () => {
    setSalesOrderOptions([]);
    try {
      const res = await GetRequest(
        `/invoice/fetchContactSales_order/${contactId}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const data = res.data.map((deal) => ({
          label: deal.sale_no,
          value: deal.id,
        }));
        setSalesOrderOptions(data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchAllSalesOrder();
  }, [contactId, selectedContact]);
  const fetchDetailsProjects = async () => {
    if (!editedMode || !project_id) return
    setIsDataFetching(true)
    try {
      const res = await GetRequest(
        `project/fetchDetailsOfProjectsForEdit/${customerId}/${project_id}/${loginUserId}`,
        { headers },
        extras
      )
      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message)
      }
      const data = res.data[0]
      // if (
      //   customer?.customer_details?.id === data?.owner_id &&
      //   customer?.customer_details?.user_type === "1"
      // ) {
      //   setIsOwnerSame(true)
      // } else {
      //   setIsOwnerSame(false)
      // }
      if (
        userType === "1"
      ) {
        setIsOwnerSame(true)
      } else if (loginUserId === data?.owner_id) {
        setIsOwnerSame(true)
      } else {
        setIsOwnerSame(false)
      }

      setContactId(data.contact_id)
      const stageData = data.stages?.map((s) => ({
        id: s.id,
        stage_name: s.stage_name,
        projectId: s.project_id
      })) || []
      reset({
        title: data.project_title || "",
        owner_id: data.owner_id?.toString() || "",
        startDate: data.start_date || "",
        endDate: data.end_date || "",
        salesOrder: data.sales_order_id?.toString() || "",
        contact: data.contact_id?.toString() || "",
        description: data.description || "",
        webhook_url: data?.webhook_url || "",
        tags: data.tags ? JSON.parse(data.tags) : [],
        projectStages: stageData,
      })
      setTags(data.tags ? JSON.parse(data.tags) : [])
      setProjectStages(stageData)
    } catch (error) {
      console.error(error)
    } finally {
      setIsDataFetching(false)
    }
  }
  useEffect(() => {
    if (editedMode) {
      fetchDetailsProjects();
    }
  }, [editedMode, project_id, isOwnerSame])
  const onDelete1 = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal1(true);
  };
  // Confirm delete and call API
  const handleConfirmedDelete1 = async () => {
    setLoading(true)
    try {
      removeProjectStage(departmentToDelete)
      toast.success("stage removed successfully")
      setShowDeleteModal1(false);
      setDepartmentToDelete(null);
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
    }
  };
  const onDelete = (stage) => {
    setDepartmentToDelete(stage.id);
    setStageToDelete(stage?.projectId)
    setShowDeleteModal(true);
  };
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `project/deleteProject_stage/${departmentToDelete}/${stageToDelete}/${loginUserId}`,
        { headers },
        extras
      );
      if (res?.status === "success") {
        toast.success(res.message);
        setProjectStages((prevStages) =>
          prevStages.filter((stage) => stage.id !== departmentToDelete)
        );
      } else if (res.status === "fail") {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false)
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
      setIndexToRemove(null);
    }
  };
  const handleFormSubmit = async (formData) => {
    const stagesWithSequence = projectStages.map((stage, index) => {
      if (typeof stage === "object") {
        return {
          sequence: index + 1,
          stage_name: stage.stage_name,
          stage_id: stage.id || "",
        }
      }
      return {
        sequence: index + 1,
        stage_name: stage,
        stage_id: "",
      }
    })
    const dataToSend = {
      template_id: "",
      description: formData?.description || "",
      customer_id: customerId,
      user_login_id: loginUserId,
      stages: stagesWithSequence,
      tags: tags,
      start_date: formData?.startDate,
      end_date: formData?.endDate,
      project_title: formData?.title,
      webhook_url: formData?.webhook_url || '',
      contact_id: formData?.contact || "",
      sales_order_id: formData?.salesOrder || "",
      owner_id: formData?.owner_id,
    }
    try {
      let res
      if (editedMode) {
        const updatedPayload = {
          ...dataToSend,
          project_id: project_id
        }
        // update existing project
        res = await PutRequest(
          `project/updateProject`,
          updatedPayload,
          { headers },
          extras
        )
      } else {
        // create new project
        res = await PostRequest(
          `project/CreateProject`,
          dataToSend,
          false,
          { headers },
          extras
        )
      }
      if (res.status === "fail" || res.status !== "success") {
        toast.error(res.message || "Error saving project")
        return
      }
      toast.success(
        editedMode ? "Project updated successfully!" : "Project created successfully!"
      )
      if (moduleName === "ProjectDashboard") {
        await refetch()
      }
      if (typeof refetch === "function") {
        await refetch();
      }
      if (typeof fetchProjectList === "function") {
        await fetchProjectList();
      }
      handleClose()
    } catch (error) {
      console.error("Error saving project:", error)
      toast.error("Something went wrong while saving project")
    }
  }
  const handleClose = () => {
    if (editedMode && isDataFetching) return;
    reset({
      title: "",
      owner_id: loginUserId || "",
      startDate: today,
      endDate: tomorrow,
      projectStages: [],
      salesOrder: "",
      contactPerson: "",
      tags: [],
      description: "",
    });
    setProjectStages([]);
    setIsOwnerSame(false)
    setCurrentStage("");
    setTags([]);
    setProjectOffcanvas(false);
    setEditMode(false);
    setProject_id(null)
    setSubmitButtonIsCliked(false);
  };
  // Handle tag change
  const handleTagChange = (newTags) => {
    const uniqueTags = [];
    newTags.forEach((tag) => {
      const lowerTag = tag.toLowerCase();
      const isDuplicate = uniqueTags.some((t) => t.toLowerCase() === lowerTag);
      if (!isDuplicate) {
        uniqueTags.push(tag);
      }
    });
    setTags(uniqueTags);
    setValue("tags", uniqueTags);
  };
  const contactOptions = useMemo(
    () =>
      contactOption.map((conta) => ({
        value: conta.contactId,
        label: conta.contactName,
        company_name: conta.company_name,
        company_id: conta.company_id,
        billingAddresses: conta.billingAddresses || [],
        shippingAddresses: conta.shippingAddresses || [],
      })),
    [contactOption]
  );
  // Custom option component for better formatting (optional)
  const CustomOption1 = ({
    innerRef,
    innerProps,
    data,
    isSelected,
    isFocused,
  }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "8px 12px",
        backgroundColor: isSelected
          ? "#007bff"
          : isFocused
            ? "#f8f9fa"
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: "500" }}>{data.label}</div>
      <div
        style={{ fontSize: "12px", color: isSelected ? "#e9ecef" : "#6c757d" }}
      >
        {data.company_name || "No Company"}
      </div>
    </div>
  );
  return (
    <>
      <Offcanvas
        className="createContactOffcanvas"
        placement="end"
        backdrop="static"
        enforceFocus={true}
        show={show}
        onHide={() => {
          if (!(editedMode && isDataFetching)) {
            handleClose();
          }
        }}
        keyboard={!(editedMode && isDataFetching)}
      >
        <Offcanvas.Header
          closeButton
          className="border-bottom border-dashed pt-3"
        >
          <div className="d-flex align-items-center gap-2">
            <div className="pt-0 ps-4">
              <Offcanvas.Title
                style={{ color: "#0791ff" }}
                className="addEnquiryHead"
              >
                {editedMode ? 'Edit Project' : 'Create Project'}
              </Offcanvas.Title>
              <p
                style={{ fontSize: "14px", color: "#b26792", lineHeight: 1.1 }}
                className=" text-secondary text-nowrap mb-0"
              >
                {editedMode ? "Modify or Edit your Project Details" : "Create New Project Here.."}
              </p>
            </div>
          </div>
          <div
            className="d-flex justify-content-end align-items-center"
            style={{ width: "70%" }}
          >
          </div>
        </Offcanvas.Header>
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmedDelete}
          isLoading={loading}
          message={"Are you sure you want to permanently delete this stage?"}
        />
        <DeleteModal
          show={showDeleteModal1}
          onClose={() => setShowDeleteModal1(false)}
          onConfirm={handleConfirmedDelete1}
          isLoading={loading}
          message={"Are you sure you want to permanently delete this stage?"}
        />
        <Offcanvas.Body
          className="pt-0"
          style={{
            position: "relative",
            pointerEvents: editedMode && isDataFetching ? "none" : "auto",
          }}
        >
          {editedMode && isDataFetching && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.7)",
                zIndex: 1050,
                pointerEvents: "all",
              }}
            >
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
          <div style={{ display: "flex", height: "100%" }}>
            <Form
              className="form-container p-3 w-100 pe-0 ps-0"
              onSubmit={handleSubmit(handleFormSubmit)}
              style={{
                margin: 0,
                overflowY: "auto",
                height: "100%",
                paddingLeft: "20px",
                position: "relative",
                opacity: editedMode && isDataFetching ? 0.6 : 1,
              }}
            >
              {/* Basic Information */}
              <div style={{ paddingTop: 10 }}>
                <Row className="w-100 ms-0 pt-3">
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formTitle"
                    >
                      <Form.Label>
                        Title <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="title"
                        control={control}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="text"
                            placeholder="Enter Project Title"
                          />
                        )}
                      />
                      {errors.title && (
                        <p
                          style={{ fontSize: "12px" }}
                          className="text-danger mt-1"
                        >
                          {errors.title.message}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    {/* Contact Owner dropdown */}
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formOwner"
                    >
                      <Form.Label style={{ marginBottom: 1 }}>
                        Contact Owner <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="owner_id"
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={customStyles}
                            {...field}
                            className="input-box-select"
                            options={leadOwner.map((lead) => ({
                              value: lead.leadId,
                              label: lead.leadName,
                            }))}
                            value={
                              leadOwner.find(
                                (lead) => lead.leadId === field.value
                              )
                                ? {
                                  value: field.value,
                                  label: leadOwner.find(
                                    (lead) => lead.leadId === field.value
                                  )?.leadName,
                                }
                                : null
                            }
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value || "");
                            }}
                            isDisabled={editedMode ? !isOwnerSame : ""}
                            isClearable={true}
                            classNamePrefix="react-select"
                            placeholder="Select Contact Owner"
                          />
                        )}
                      />
                      {errors.owner_id && (
                        <p
                          style={{ fontSize: "12px" }}
                          className="text-danger mt-1"
                        >
                          {errors.owner_id.message}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                {/* {Date field} */}
                <Row className="w-100 ms-0 pt-3">
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formstartDate"
                    >
                      <Form.Label style={{ marginBottom: 1 }}>
                        Start Date{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="startDate"
                        control={control}
                        rules={{
                          required: "Start date  is required",
                          validate: (value) => {
                            const qDate = new Date(value);
                            const tDate = new Date(today);

                            if (qDate < tDate) {
                              return "Sales order date cannot be in the past";
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="date"
                            placeholder="Select Start Date"
                          //  min={editedMode ? "" : today} 

                          />
                        )}
                      />
                      {errors.startDate && (
                        <p
                          className="text-danger mt-1"
                          style={{ fontSize: "12px" }}
                        >
                          {errors.startDate.message}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formExpiryDate"
                    >
                      <Form.Label style={{ marginBottom: 1 }}>
                        End Date{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="endDate"
                        control={control}
                        rules={{
                          required: "End Date is required",
                          validate: (value) => {
                            const qDate = new Date(StartDate);
                            const eDate = new Date(value);
                            if (eDate <= qDate) {
                              return "End date must be after start date";
                            }
                            return true;
                          },
                        }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="date"
                            placeholder="Select End Date"
                            min={StartDate}
                          />
                        )}
                      />
                      {eDate < qDate && (
                        <p
                          className="text-danger mt-1"
                          style={{ fontSize: "12px" }}
                        >
                          End date must be after start date
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="w-100 ms-0 pt-3">
                  <Col md={12}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formProjectStages"
                    >
                      <Form.Label>
                        Project Stages <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="d-flex gap-2 mb-2">
                        <Form.Control
                          type="text"
                          placeholder="Enter project stage"
                          value={currentStage}
                          onChange={(e) => setCurrentStage(e.target.value)}
                          onKeyPress={handleStageKeyPress}
                        />
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={addProjectStage}
                          disabled={!currentStage.trim()}
                          style={{ height: "51px", width: "62px" }}
                        >
                          <div className="d-flex align-items-center justify-content-center">
                            <FontAwesomeIcon icon={faPlus} />
                            Add
                          </div>
                        </button>
                      </div>
                      {projectStages.map((stage, index) => (
                        <div
                          key={index}
                          id={stage.id}
                          draggable   //
                          onDragStart={(e) => handleDragStart(e, index)} //
                          onDragOver={handleDragOver} // 
                          onDrop={(e) => handleDrop(e, index)}
                          className="d-flex justify-content-between align-items-center bg-light rounded p-2 mb-1"
                          style={{ cursor: "move" }}
                        >
                          <div>
                            <FontAwesomeIcon icon={faEquals} />
                            <span style={{ marginLeft: "10px" }}>
                              {editIndex === index ? (
                                <Form.Control
                                  type="text"
                                  value={editValue}
                                  onChange={(e) => setEditValue(e.target.value)}
                                  size="sm"
                                  style={{ width: "200px", display: "inline-block" }}
                                />
                              ) : (
                                <span style={{ marginLeft: "20px" }}>
                                  {typeof stage === "object" ? stage.stage_name : stage}
                                </span>
                              )}
                            </span>
                          </div>
                          <div className="d-flex gap-2">
                            {editIndex === index ? (
                              <Button
                                variant="outline-success"
                                size="sm"
                                onClick={() => handleSaveEdit(index)}
                              >
                                <FontAwesomeIcon icon={faCheck} />
                              </Button>
                            ) : (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEdit(index)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </Button>
                            )}
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => {
                                if (editedMode) {

                                  if (stage.id) {
                                    onDelete(stage);
                                  } else {
                                    onDelete1(index)
                                  }
                                } else {
                                  removeProjectStage(index);
                                }
                              }}
                            >
                              {editedMode ? <FontAwesomeIcon icon={faTrash} /> : "X"}
                            </Button>
                          </div>
                        </div>
                      ))}
                      {errors.projectStages && (
                        <p
                          style={{ fontSize: "12px" }}
                          className="text-danger mt-1"
                        >
                          {projectStages?.length === 0 && errors.projectStages.message}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="w-100 ms-0 pt-3">
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formContact"
                    >
                      <Form.Label style={{ marginBottom: 1 }}>
                        Contact <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="contact"
                        control={control}
                        rules={{ required: "Contact is required" }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={contactOptions}
                              placeholder="Select Contact"
                              classNamePrefix="react-select"
                              styles={customStyles}
                              components={{
                                Option: CustomOption1,
                              }}
                              value={
                                contactOptions?.find(
                                  (opt) => opt.value === field.value
                                ) || selectedContact
                              }
                              onChange={(selected) =>
                                handleSelectChange(
                                  "contact",
                                  selected,
                                  field.onChange
                                )
                              }
                            />
                          );
                        }}
                      />
                      {errors.contact && (
                        <p
                          className="text-danger mt-1"
                          style={{ fontSize: "12px" }}
                        >
                          {"Contact name is required"}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 focus-z-index position-relative"
                      controlId="formSalesOrder"
                    >
                      <Form.Label style={{ marginBottom: 1 }}>
                        Sales Order
                      </Form.Label>
                      <Controller
                        name="salesOrder"
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={customStyles}
                            {...field}
                            className="input-box-select"
                            options={salesOrderOptions}
                            value={
                              salesOrderOptions.find(
                                (option) => option.value === field.value
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value || "");
                            }}
                            isClearable={true}
                            classNamePrefix="react-select"
                            placeholder="Select Sales Order"
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {/* Tags and Description */}
                <div className="">
                  <Row className="w-100 ms-0 mt-3 mb-5">
                    <Col md={6}>
                      <Form.Group
                        className="mb-3 position-relative d-flex flex-column focus-z-index"
                        controlId="formTags"
                      >
                        <Form.Label
                          style={{ marginBottom: "2px", marginTop: "2px" }}
                        >
                          Tags
                        </Form.Label>
                        <div
                          style={{
                            border: "1px solid #d3d3d3",
                            borderRadius: "5px",
                            minHeight: "38px",
                            display: "flex",
                            justifyItems: "center",
                            padding: "3px",
                            background: "#fff",
                          }}
                        >
                          <TagsInput
                            value={tags}
                            className="rounded-1 custom"
                            onChange={handleTagChange}
                            inputProps={{
                              placeholder: "Press enter to add."
                            }}
                          />
                          <style>
                            {`
                              .react-tagsinput-tag {
                                  background-color : #1770ff !important;
                                  color : white;
                              }
                              .react-tagsinput-remove{
                                  color : white;
                              }
                              .react-tagsinput-input{
                                  width : 158px;
                                  padding: 0rem 0rem 0rem !important;
                              }
                              .custom{
                                  padding-left : 0.5rem;
                                  margin-top : 9px;
                              }
                          `}
                          </style>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group
                        className="mb-3 focus-z-index position-relative"
                        controlId="formTitle"
                      >
                        <Form.Label>
                          Webhook Url
                        </Form.Label>
                        <Controller
                          name="webhook_url"
                          control={control}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Enter your webhook url"
                            />
                          )}
                        />
                        {errors.webhook_url && (
                          <p
                            style={{ fontSize: "12px" }}
                            className="text-danger mt-1"
                          >
                            {errors.webhook_url.message}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group
                        className="mb-3 d-flex flex-column focus-z-index position-relative"
                        controlId="formDescription"
                      >
                        <Form.Label
                          className="textareaLables"
                          style={{ marginBottom: "2px", marginTop: "2px" }}
                        >
                          Description
                        </Form.Label>
                        <Controller
                          name="description"
                          control={control}
                          render={({ field }) => (
                            <Form.Control {...field} as={"textarea"} rows={4} />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>
              <div style={{ height: "80px" }}></div>
              {/* Save and Cancel buttons */}
              <div
                style={{
                  position: "fixed",
                  width: "60%",
                  bottom: 0,
                  height: "74px",
                  zIndex: 50,
                  right: 0,
                  background: "#fefefe",
                  paddingRight: "20px",
                  borderTop: "1px solid #c4ebf7",
                }}
              >
                <div className="d-flex justify-content-end gap-2 pt-4">
                  <CancelBtn
                    type={'button'}
                    onClick={() => {
                      if (!(editedMode && isDataFetching)) {
                        handleClose();
                      }
                    }}
                    customClassName={"me-2"}
                    submitClicked={editedMode && isDataFetching}
                  />
                  <SubmitBtn
                    type={'submit'}
                    onClick={() => {
                      setSubmitButtonIsCliked(true);
                      setIsOwnerSame(false)
                    }}
                    loading={isSubmitting}
                  />
                </div>
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
